import Routes from '@/constants/Routes';
import { loginRoute } from '@/helpers/loginHelpers';
import { reloadToLogin } from '@/helpers/sessionHelpers';
import { useAuthStore } from '@/services/stores/authStore';
import { START_LOCATION, type RouteLocationNormalized, type RouteLocationRaw } from 'vue-router';

/** The global router.beforeEach: anonymous pages are open, others need a login and one of meta.roles. */
export function routeGuard(to: RouteLocationNormalized, from: RouteLocationNormalized = START_LOCATION): RouteLocationRaw | false | undefined {
    // Check if we're in login area, never redirect in that case
    if (to.meta.anonymous) {
        return;
    }

    // Check if user is authenticated and cookie values are present for the front-end. If not, try to fetch from api
    const authStore = useAuthStore();

    if (!authStore.isAuthenticated()) {
        // On the first navigation nothing is loaded yet. Later the session ended while the app ran (a logout in
        // another tab): reload, so the hub connection and the cached stores of that session go too. Either way the
        // login continues with the page asked for.
        if (from === START_LOCATION) {
            return loginRoute(to.fullPath);
        }

        reloadToLogin(to.fullPath);
        return false;
    }

    if (to.meta.roles && !authStore.hasRole(to.meta.roles)) {
        // Awww... so close but station(s) and/or permission(s) do not match
        return { name: Routes.AccessDenied };
    }
}
